import { createReducer } from '@reduxjs/toolkit';

import { Room, TableItem } from '../types';
import {
	roomClose,
	roomError,
	roomLoaded,
	roomOpen,
	tablesAppend,
	tablesRemove,
	tablesSet,
	tablesUpdateSeats,
} from './roomActions';

// NOTE: We keep socket tables (TableItem[]) and HTTP "my active tables" (TableLite[]) separate.
export type RoomState = {
	error?: string;
	// SOCKET lobby tables (rich objects: seats_taken, number_of_seats, locked, owner_id, etc.)
	tables: TableItem[];
	room?: Room;
};

const initialState: RoomState = {
	tables: [],
};

export const roomReducer = createReducer(initialState, b => {
	// ----------- Open/Close room -----------
	b.addCase(roomOpen, s => {
		// s.loading = true;
		s.error = undefined;
		s.tables = [];
	});
	b.addCase(roomLoaded, (s, a) => {
		s.error = undefined;
		s.room = a.payload;
	});
	b.addCase(roomError, (s, a) => {
		s.error = a.payload;
	});
	b.addCase(roomClose, s => {
		s.room = undefined;
		s.tables = [];
		s.error = undefined;
	});

	// ----------- SOCKET: lobby tables (TableItem[]) -----------
	b.addCase(tablesSet, (s, a) => {
		s.tables = a.payload;
	});
	b.addCase(tablesAppend, (s, a) => {
		const incoming = a.payload.filter(t => !s.tables.find(x => x.id === t.id));
		s.tables.push(...incoming);
	});
	b.addCase(tablesUpdateSeats, (s, a) => {
		// String-compare: ids arrive as uuids from the socket but may sit as
		// number-typed values in older fixtures.
		const t = s.tables.find(x => String(x.id) === String(a.payload.id));
		if (t)
			t.seats_taken = Math.max(
				0,
				Math.min(t.number_of_seats, t.seats_taken + (a.payload.inc ? 1 : -1)),
			);
	});
	b.addCase(tablesRemove, (s, a) => {
		s.tables = s.tables.filter(t => String(t.id) !== String(a.payload));
	});
});
